export default __webpack_public_path__ + "static/DMSans-BoldItalic-43ac31bf9a3f582ff8271834b0669358.woff";